import { render, staticRenderFns } from "./ChoosePositionGlobe.vue?vue&type=template&id=9203e7fe&scoped=true&"
import script from "./ChoosePositionGlobe.vue?vue&type=script&lang=js&"
export * from "./ChoosePositionGlobe.vue?vue&type=script&lang=js&"
import style0 from "./ChoosePositionGlobe.vue?vue&type=style&index=0&id=9203e7fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9203e7fe",
  null
  
)

export default component.exports